import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';
import TermsModal from './TermsModal';

// Mobile terms row: the link (or ticking the box) opens the terms modal, whose Agree button
// ticks it - the full terms copy isn't shown inline on small screens.
const MobileTermsCheckbox = ({ checked, onChange }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Checkbox
        className="spc-terms-checkbox spc-terms-checkbox--mobile"
        checked={checked}
        onChange={(e) => (e.target.checked ? setOpen(true) : onChange(false))}
      >
        <a
          href="#terms"
          className="spc-terms-link"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen(true);
          }}
        >
          {t('checkout.termsConditions')}
        </a>
      </Checkbox>
      {open && <TermsModal tcAgree={checked} setTcAgree={onChange} onClose={() => setOpen(false)} />}
    </>
  );
};

MobileTermsCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default MobileTermsCheckbox;
